import { createFileRoute } from '@tanstack/react-router'
import { CompanyEditorPage } from '@/features/companies/editor'

export const Route = createFileRoute('/companies_/$companyId/edit')({
  component: RouteComponent,
})

function RouteComponent() {
  const { companyId } = Route.useParams()
  return <CompanyEditorPage companyId={companyId} />
}
